// apps/web/app/microgrid/lit/components/HowItWorks.tsx
'use client';
import React, { useEffect, useRef } from 'react';
import SystemDiagram from './SystemDiagram';
import { sectionViewOnce } from '../components/ga'
import './styles/HowItWorks.css';

const HowItWorks: React.FC = () => {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => ref.current ? sectionViewOnce(ref.current, 'how_it_works_lit') : undefined, []);
  return (
    <section id="how-it-works" className="how-it-works" ref={ref}>
      <h2>Simple Setup, Powerful Control</h2>
      <div className="how-it-works-content">
        <SystemDiagram />
        <div className="bullet-points">
          <ul>
            <li><strong>Weatherproof Design:</strong> Built to withstand the elements, all year round.</li>
            <li><strong>Smart App Control:</strong> Customize colors, schedules, and effects from your phone.</li>
            <li><strong>Efficient LEDs:</strong> Brilliant lighting that saves on energy costs.</li>
            <li><strong>Professional Installation:</strong> Our certified team ensures a flawless setup.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
